<template>
  <v-container class="mt-0">
      <v-layout row wrap justify-center v-if="loading">
        <v-flex xs12 sm8 md6 class="text-xs-center">
          <v-progress-circular 
          indeterminate 
          color="primary"
          :width="7"
          :size="70"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    <v-layout row v-else>
      <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
        <h1 class="mt-3 text-xs-center">{{ alert.alertName }}</h1>
        <v-divider></v-divider>
        <template v-if="userIsCreator">
          <v-spacer></v-spacer>
          <app-edit-alert-dialog :alert="alert"></app-edit-alert-dialog>
        </template>
      </v-flex>
    </v-layout>
    
  </v-container>
</template>

<script>
export default {
  data () {
    return {
    //  dialog: false
    }
  },
  props: ['id'],
  computed: {
    alert () {
      console.log('CURRENT ITEM: ' + this.id)
      return this.$store.getters.loadedAlert(this.id)
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    userIsCreator () {
      if (!this.userIsAuthenticated) {
        return false
      }
      return this.$store.getters.user.id === this.alert.creatorId
    },
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>


// WEBPACK FOOTER //
// Alert.vue?6110606b